module.exports = __webpack_public_path__ + "static/img/step_3-button.8e4bc7df.png";